import { Box, Container, Typography } from "@material-ui/core";
import React from "react";
import useCountry from "../../../../../hooks/use-country";
import useSubcountry from "../../../../../hooks/use-subcountry";
import WarningSvg from "./warning.svg";
import WarningCaliforniaSvg from "./warning-california.svg";

export default function LegalWarnings() {
  const country = useCountry();
  const { subcountry } = useSubcountry();

  return (
    <>
      {/* California P65 warning */}
      {country === "US" && subcountry === "CA" && (
        <Box mb={{ xs: 4, md: 8 }}>
          <Container maxWidth="md">
            <Box
              bgcolor="grey.100"
              borderRadius="3px"
              p={1.5}
              width="100%"
              display="flex"
              alignItems="center"
            >
              <Box mr={1} display="flex" alignItems="center">
                <img
                  src={WarningCaliforniaSvg}
                  alt="P65 Warning"
                  width="24px"
                  height="24px"
                />
              </Box>
              <Typography variant="body2">
                <strong>WARNING:</strong> Cancer and Reproductive Harm{" "}
                <a
                  href="https://www.p65warnings.ca.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  www.P65Warnings.ca.gov
                </a>
                .
              </Typography>
            </Box>
          </Container>
        </Box>
      )}

      {/* Washington legal warning */}
      {country === "US" && subcountry === "WA" && (
        <Box mb={{ xs: 4, md: 8 }}>
          <Container maxWidth="md">
            <Box
              bgcolor="grey.100"
              borderRadius="3px"
              width="100%"
              display="flex"
              alignItems="center"
              p={2}
            >
              <Box mr={1} display="flex" alignItems="center">
                <img
                  src={WarningSvg}
                  alt="Warning"
                  width="24px"
                  height="24px"
                />
              </Box>
              <Typography variant="body2">
                For use only by adults 21 and older. Keep out of the reach of
                children.
              </Typography>
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
}
